import { SxProps, Theme } from "@mui/material";

export interface DialogStyleProfile {
  overlay: SxProps<Theme>;
  sheet: SxProps<Theme>;
  title: SxProps<Theme>;
  alert: SxProps<Theme>;
  cancelButton: SxProps<Theme>;
  confirmButton: SxProps<Theme>;
}

export const dialogStyles: Record<string, DialogStyleProfile> = {
  // Profile 1: Mobile Bottom Sheet (Warning Variant)
  bottomSheetWarning: {
    overlay: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(15, 23, 42, 0.4)",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-end",
      zIndex: 100000,
      pointerEvents: "auto",
    },
    sheet: {
      display: "flex",
      width: "100%",
      maxWidth: 480,
      height: "auto",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "var(--2, 16px)",
      borderRadius: "var(--Border-Radius-20, 20px) var(--Border-Radius-20, 20px) 0 0",
      padding: "20px 16px calc(20px + env(safe-area-inset-bottom, 0px)) 16px",
      background: "linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.15) 100%), var(--background-paper, #FFF)",
      boxShadow: "0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14)",
      boxSizing: "border-box",
    },
    title: {
      width: "100%",
      color: "var(--text-primary, #475569)",
      fontFamily: "var(--fontFamily, Inter), sans-serif",
      fontSize: "var(--_fontSize-typography-h6, 20px)",
      fontWeight: "var(--fontWeightMedium, 500)",
      lineHeight: "160%",
      letterSpacing: "0.15px",
    },
    alert: {
      width: "100%",
      padding: "6px 16px",
      borderRadius: "var(--borderRadius-8, 8px)",
      borderColor: "var(--warning-_states-outlinedBorder, rgba(239, 108, 0, 0.50))",
      backgroundColor: "var(--_components-alert-warning-background, #FFF4E5)",
      color: "var(--_components-alert-warning-color, #663C00)",
      boxSizing: "border-box",
    },
    cancelButton: {
      color: "var(--secondary-main, #64748B)",
      textTransform: "none",
      fontWeight: 500,
      fontSize: "14px",
      padding: "6px 12px",
      borderRadius: "var(--borderRadius-4, 4px)",
    },
    confirmButton: {
      backgroundColor: "var(--primary-main, #155DFC)",
      color: "var(--primary-contrastText, #FFF)",
      textTransform: "none",
      fontWeight: 500,
      fontSize: "14px",
      padding: "6px 16px",
      borderRadius: "var(--borderRadius-4, 4px)",
      boxShadow: "0 1px 5px 0 rgba(0, 0, 0, 0.12)",
      "&:hover": {
        backgroundColor: "#0d4ed8",
      },
    },
  },

  // Profile 2: Centered Modal (Error / Delete Variant)
  centerModalError: {
    overlay: {
      position: "fixed",
      inset: 0,
      backgroundColor: "rgba(15, 23, 42, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: 2,
      zIndex: 100000,
      pointerEvents: "auto",
    },
    sheet: {
      display: "flex",
      width: "100%",
      maxWidth: 420,
      height: "auto",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "16px",
      borderRadius: "20px",
      padding: "24px",
      background: "#FFF",
      boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
      boxSizing: "border-box",
    },
    title: {
      width: "100%",
      color: "#1e293b",
      fontWeight: 600,
      fontSize: "18px",
    },
    alert: {
      width: "100%",
      padding: "12px 16px",
      borderRadius: "8px",
      borderColor: "#f87171",
      backgroundColor: "#fef2f2",
      color: "#991b1b",
    },
    cancelButton: {
      color: "#64748b",
      textTransform: "none",
      fontWeight: 500,
    },
    confirmButton: {
      backgroundColor: "#dc2626",
      color: "#FFF",
      textTransform: "none",
      fontWeight: 500,
      "&:hover": {
        backgroundColor: "#b91c1c",
      },
    },
  },
};